export interface ModalOptions {
  title?: string
  content: string | Node
  onClose?: () => void
}

export interface ModalHandle {
  close: () => void
  el: HTMLElement
}

/**
 * Opens a modal. Direction is inherited from the document, not
 * hardcoded — the component never assumes LTR.
 */
export function openModal(options: ModalOptions): ModalHandle {
  const overlay = document.createElement('div')
  overlay.className = 'sn-modal-overlay'

  const modal = document.createElement('div')
  modal.className = 'sn-modal'
  modal.setAttribute('role', 'dialog')
  modal.setAttribute('aria-modal', 'true')

  if (options.title) {
    const heading = document.createElement('h2')
    heading.className = 'sn-modal__title'
    heading.textContent = options.title
    modal.appendChild(heading)
  }

  const body = document.createElement('div')
  body.className = 'sn-modal__body'
  if (typeof options.content === 'string') {
    body.textContent = options.content
  }
  else {
    body.appendChild(options.content)
  }
  modal.appendChild(body)

  const closeBtn = document.createElement('button')
  closeBtn.className = 'sn-modal__close'
  closeBtn.setAttribute('aria-label', 'Close')
  closeBtn.textContent = '\u00D7'
  modal.appendChild(closeBtn)

  overlay.appendChild(modal)
  document.body.appendChild(overlay)
  document.body.classList.add('sn-scroll-locked')

  function close(): void {
    overlay.remove()
    document.body.classList.remove('sn-scroll-locked')
    options.onClose?.()
  }

  closeBtn.addEventListener('click', close)
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay)
      close()
  })
  document.addEventListener('keydown', function onKey(e) {
    if (e.key === 'Escape') {
      close()
      document.removeEventListener('keydown', onKey)
    }
  })

  requestAnimationFrame(() => overlay.classList.add('sn-modal-overlay--visible'))

  return { close, el: overlay }
}
